import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Amount.scss';

export default function Amount(props) {
  const { selected, className, currentAmountClassName, currentAmountInPercentages } = props;

  return (
    <span className={classnames(className, 'new-amount-total-amount')}>
      <span
        style={{ width: `${currentAmountInPercentages}%` }}
        className={classnames(currentAmountClassName, 'new-amount-current-amount', {
          'new-amount-current-amount-selected': selected,
        })}
      />
    </span>
  );
}

Amount.propTypes = {
  selected: PropTypes.bool.isRequired,
  className: PropTypes.string,
  currentAmountClassName: PropTypes.string,
  currentAmountInPercentages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
